module.exports = __webpack_public_path__ + "static/media/14.7bde1175.jpeg";